import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Home from '../src/pages/public/Home';
import NotFound from '../src/pages/public/NotFound';
import PublicLayout from '../src/pages/public/PublicLayout';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<PublicLayout />}>
          <Route index element={<Home />} />
          <Route path='*' element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
